module.exports = __webpack_public_path__ + "static/bg.112e5ac0.png";